import { makeStyles } from '@material-ui/core'
import React from 'react'

import { Container, PageTitle } from 'src/modules/ui'

import ProfileForm from './ProfileForm'
import ChangePasswordForm from './ChangePasswordForm'

const useStyles = makeStyles(theme => ({
  form: {
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
}))

const Profile = () => {
  const classes = useStyles()

  return (
    <Container>
      <PageTitle>User Profile</PageTitle>
      <div className={classes.form}>
        <ProfileForm />
      </div>
      <div className={classes.form}>
        <ChangePasswordForm />
      </div>
    </Container>
  )
}

export default Profile
